import $ from 'jquery';
import 'owl.carousel';
import Select from './components/select';

export default class Mission {
    constructor() {
        this.ajaxState = false;
        this.scrollPos = 0;
        this.loader = '<div class="wait-loading"></div>';
        this.scrollInstance = null;
        this.hrefOfpage = window.location.href.split(window.location.origin)[1];
    }

    init() {
        this.typeDisplayHandler();
        // this.filterHandler();
        // this.paginationHandler();
        this.readMoreHandler();
        this.bodyHandler();
        this.toggleProject();
        this.goBackHandler();
        this.showDetails();
        this.showProjectHandler(this);
        this.onCloseModal();
        this.onShownModal();
    }

    typeDisplayHandler() {
        let selector = $('.mission-type-js');

        selector.on('change', function() {
                $(this).parents('.filters').find('.btn').trigger('click');

                if ($(this).val() == 1) {
                    $('body').removeClass('page-missions-list').addClass('page-missions-map');
                } else {
                    $('body').removeClass('page-missions-map').addClass('page-missions-list');
                }

        });
    }

    // filterHandler() {
        
    //     $('.filters form').submit((event, pageId) => {
    //         // Stop the browser from submitting the form.
    //         event.preventDefault();

    //         if (!this.ajaxState) {
    //             this.ajaxState = true;
    //             $('body').append(this.loader);
    //             pageId = pageId == "undefined" ? 1 : pageId;
    //             $(event.target).find('input[name="page"]').val(pageId);
    //             let url = $(event.target).attr('action');
    //             let data = $(event.target).serialize();
    //             $.get(url, data, (result) => {
    //                 let obj = JSON.parse(result);
    //                 let content = (obj.items == "") ? '<p class="no-result">Aucun résultat trouvé !</p>' : obj.items;
    //                 $('.missions-list-results').html(content);
    //             }).done(() => {
    //                 this.ajaxState = false;
    //                 $('.wait-loading').remove();
    //             });
    //         }

            
    //     });
    // }

    // paginationHandler() {
    //     $(document).on('click', '.pagination a', (event) => {
    //         // Stop the browser from submitting the form.
    //         event.preventDefault();

    //         let id = $(event.target).data('page');
    //         let form = $('.filters form');
            
    //         if (!this.ajaxState) {
    //             let pageId = id;
    //             // send filter form
    //             form.trigger('submit', [pageId]);

    //             $('html, body').animate({
    //                 scrollTop: $(".missions-list-results").offset().top
    //             }, 500);
    //         }
    //     });
    // }

    readMoreHandler() {
        const _self = this;
        
        $(document).on('click', '.missions-list-results .btn-more, .missions-list-results .post-title a, .missions-list-results .missions-position-item', function(e) {
            e.preventDefault();            
            
            const that = $(this); 
            
            let url = $(this).get(0).hasAttribute("data-action") ? $(this).data('action') : $(".missions-list-results").data('action');

            let id = $(this).get(0).hasAttribute("data-action") ? $(this).data('id') : $(this).parents('.post').data('id');

            
            $('body').append(_self.loader);
                        

            if (url.indexOf('listing-missions') == -1) {

                if (($('body').hasClass("page-missions-map") && window.matchMedia("(max-width: 640px)").matches)) {
                    
                    if (!$(this).parents().hasClass('list-fiche-mission') && !$(this).hasClass('mob-shwo-detail-mission')) {
                        $('.mob-shwo-detail-mission').remove();
                        let link = '<a href="#" class="btn btn-primary rounded-0 mob-shwo-detail-mission btn-more" data-action="' + url + '" data-id="' + id + '">Voir la mission</a>';
                        $('.page-missions-map .missions-list-results').append(link);
                        $('.wait-loading').remove();
                        return;
                    }
                    
                }
          
                $(this).addClass('active');
                let baseUrl = window.location.origin;
                let idUrl = that.get(0).hasAttribute('href') ? that.attr('href') : '';
              
                $.ajax({
                    url: url,
                    type: "get",
                    data: {
                        id: id,
                    },
                    success:  (response) => {

                        

                        let obj = typeof response == 'string' ? JSON.parse(response) : response;
                       
                        $('#main').append(obj.items).promise().done( ()=> {
                            
                            // show modal
                            $('.wait-loading').remove();
                            $('.modal-mission').modal('show');

                            _self.onCloseModal();
                            _self.onShownModal();

                            _self.showDetails();
                           
                            
                            idUrl = that.get(0).hasAttribute('href') ? that.attr('href') : '';
        
                            history.pushState({}, '', idUrl.split(baseUrl)[1]);
                            
                        });
                    },
                    error: function (xhr) {
                        console.error(xhr);
                    }
                });

                /*$(document).on('click', '.modal-mission .go-back',function (e) {
                    e.preventDefault();
                    let target = $(this).find('span:not(.d-none)').data('target');

                    if (target == ".details-mission-wrapper") {
                        let url = $('._mission').data('url');
                        history.pushState({}, '', url.split(baseUrl)[1]);
                    } 
                });*/

            } else {
                
                let parent = (window.matchMedia("(max-width: 640px)").matches) ? $(this).parents('.missions-body') : $(this).parents('.missions-map');
                let positionTop = $(this).position().top - 17;
                let positionLeft = $(this).position().left + 12;

                if ($('.missions-position-item.active').length) {
                    $('.missions-position-item.active').removeClass('active');
                }

                $(this).addClass('active');
            
                $.get(url, {id: id }, function (response) {
                    
                    $('.wait-loading').remove();

                    let obj = typeof response == 'string' ? JSON.parse(response) : response;

                    parent.append(obj.items).promise().done(function () {

                        if (!window.matchMedia("(max-width: 640px)").matches) {

                            $(this).find('.list-fiche-mission').css({
                                'left': positionLeft + 'px',
                                'top': positionTop + 'px',
                                opacity: 1
                            });

                        }
                        
                    });
                });

            };

        });
    }

    showDetails() {
        // Handler detail
        $(document).on('click', '.post-show-step , .post-red .btn-more',  function (e) {
            e.preventDefault();
            if (!window.matchMedia("(max-width: 640px)").matches) {

                $('.modal-mission').find('.modal-dialog').css('right', 0);
                $(".page-missions-map .modal-backdrop.show").css('opacity', .95);

            } 

        });
    }

    onShownModal() {
        const _self = this;
        $('.modal-mission').on('shown.bs.modal', function(e) {
            //$('html').addClass('blockScroll');
          /*_self.scrollPos = $(document).scrollTop();
          //
          
          console.log(_self.scrollPos, $(document).scrollTop());
          $('body').css({
            overflow: 'hidden',
            position: 'fixed',
            top: -_self.scrollPos
          });*/
          $('html').css('overflow', 'hidden');
            _self.customScroll($(this));
            $('body').css('overflow', 'hidden');
            if (window.matchMedia("(max-width: 640px)").matches) {
                $(this).find('.modal-body > div').append($(this).find('.button-close'));    
            }
            
        });
    }

    customScroll(parent) {

        if (!parent.find('.scroll-pane').length) return;
        if (parent.find('.posts-news') && ($('.content-single-project').length == 0)) {
            let totalWidth = parent.find('.scroll-pane').find('.row').find('.post').outerWidth() * parent.find('.scroll-pane').find('.row').find('.post').length;
            let height = parent.find('.scroll-pane').find('.row').find('.post').outerHeight();
            let marginBottom = (window.matchMedia("(max-width: 640px)").matches) ? 35 : 47;

            parent.find('.scroll-pane').css('height', height + marginBottom + 'px');
            parent.find('.scroll-pane').find('.row').css('width', totalWidth + 'px');
        }

        //setTimeout(function(){ 

            if ( $('.content-single-project').length != 0 ) {
                let totalWidth = parent.find('.scroll-pane').find('.row').find('.post').outerWidth() * parent.find('.scroll-pane').find('.row').find('.post').length;
                
                //let height = $('.details-project-wrapper .posts-news .post').outerHeight();
                
                let height = 395;
                let marginBottom = (window.matchMedia("(max-width: 640px)").matches) ? 35 : 47;
    
                parent.find('.scroll-pane').css('height', height + marginBottom + 'px');
                parent.find('.scroll-pane').find('.row').css('width', totalWidth + 'px');
                
                $('.posts-news .jspVerticalBar').css('opacity',0);
                
            }
        // }, 10);

        

        if (this.scrollInstance != null) {

            this.scrollInstance.destroy();
            
            this.scrollInstance = parent.find('.scroll-pane').jScrollPane().data().jsp;
            
        } else {
            this.scrollInstance = parent.find('.scroll-pane').jScrollPane().data().jsp;
        }
        
    }

    onCloseModal() {
      const _self = this;

      $(document).on('click', '.modal-mission .button-close',function (e) {
            let baseUrl = window.location.origin;
            let url = $('.modal-mission .button-close').data('url');
            history.pushState({}, '', url.split(baseUrl)[1]);
        });

        if (!$('.modal-mission').length)  return;
      $("body").unbind('scroll');
        $('.modal-mission').on('hidden.bs.modal',  (e) => {
          $('html').css('overflow', 'auto');
         /* $('body').css({
            overflow: '',
            position: '',
            top: ''
          });
          //console.log(_self.scrollPos);
          
            $("html,body").animate({
              scrollTop: _self.scrollPos
            }, 500);*/
          
          
            //$('html').removeClass('blockScroll');
            if ($('.modal-mission').length) {
                // remove old modal
                $('.modal-mission').remove();
            }
            
            if ($('.missions-position-item.active').length && $('.missions-position-item.active').data('action').indexOf('listing-missions') == -1) {
                $('.missions-position-item.active').removeClass('active');
            }
            
            if ($('.btn-more.active').length) {
                $('.btn-more.active').removeClass('active');
            }

            if ($('.mob-shwo-detail-mission').length) {
                $('.mob-shwo-detail-mission').remove();
            }

            if ( $('.missions-list-results').length == 0) {
                history.pushState({}, '', this.hrefOfpage);
            }
            
        });
    }

    bodyHandler() {
        $(document).on('click', function (e) {
            if ($('body.page-missions-map').length) {

               
                if ( $(e.target).closest('.exeptLink').length == 0) {
                    if ($(e.target).closest('.missions-position-item').length != 0 || $(e.target).closest('.list-fiche-mission').length != 0 || $(e.target).closest('.modal-plug .modal-dialog').length != 0 || (!($(e.target).closest('exeptLink'))))
                        return false;
                }
                if ($('.missions-position-item.active').length && $('.missions-position-item.active').data('action').indexOf('listing-missions') != -1) {
                    $('.missions-position-item.active').removeClass('active');
                    $('.list-fiche-mission').remove();
                }
            }

        });
    }

    mobMediaCarrousel() {
        if (!window.matchMedia("(max-width: 640px)").matches) return;

        let owl = $('.post-details-media');

        // New html
        let content = '';
        $.each($('.post-details-media').find('.row').find('>div'), function() {
            content += $(this).html();
        });
       

        $('.post-details-media').addClass('owl-carousel').html(content).promise().done(function() {
            owl.owlCarousel({
                items: 1,
                loop: true
            });
        });
    }

    toggleProject() {
        const _self = this;
        $(document).on('click', '.mission-button', function (e) {
            e.preventDefault();
            let wrapper = $(this).parents('.modal-content-left').next(); 
            
            wrapper.find('.details-mission-wrapper').removeClass('d-none');
            wrapper.find('.details-project-wrapper').addClass('d-none');
            wrapper.find('.go-back').trigger('click');
            // init scroll
            _self.customScroll($(".details-mission-wrapper"));
        });
    }

    goBackHandler() {
        let baseUrl = window.location.origin;
        $(document).on('click', '.modal-mission .go-back',function (e) {
            e.preventDefault();
            let target = $(this).find('span:not(.d-none)').data('target');
            $('.go-back').removeClass('d-none');
            if (target == ".details-mission-wrapper") {
                $(".modal-dialog").removeAttr('style');
                if(window.matchMedia("(max-width: 768px)").matches) {
                  $('.button-close').trigger('click');
                }


            } else {
                $(this).find('span').removeClass('d-none');
                $(target).addClass('d-none');
                
                $('.details-mission-wrapper').removeClass('d-none');
                $(this).find('span[data-target="' + target + '"]').addClass('d-none');
                $('.modal-content-left .post-red').removeClass('show-project');

                let url = $('._project').data('url');
                history.pushState({}, '', url.split(baseUrl)[1]);
            }

        });
    }

    showProjectHandler(that) {
        $(document).on('click', '.modal-mission .posts-project .post', function (e) {
            e.preventDefault();
            const _that = $(this); 
            
            let url = $(this).parents(".posts-project").data("action");
            let id = $(this).find('.btn-more').data('id');
            let wrapper = $(this).parents('.post-details'); 

            //wrapper.append($(that.loader).css('position', 'absolute'));

            $.get(url, { id: id }, function (response) {

                let obj = typeof response == 'string' ? JSON.parse(response) : response;

                wrapper.find('.details-project-wrapper').html(obj.items).promise().done(function () {
                    //$('.wait-loading').remove();
                    wrapper.find('.details-mission-wrapper').addClass('d-none');
                    $('.modal-content-left .post-red').addClass('show-project');
                    wrapper.find('.go-back').find('span').addClass('d-none');
                    if (window.matchMedia("(max-width: 640px)").matches){
                      wrapper.find('.go-back').addClass('d-none');
                    } 
                    wrapper.find('.go-back').find('span[data-target=".details-project-wrapper"]').removeClass('d-none');
                    this.removeClass('d-none');
                    that.mobMediaCarrousel();
                    that.customScroll(wrapper.find('.details-project-wrapper'));
                    
                    let baseUrl = window.location.origin;
                    let idUrl =  _that.data('url');

                    history.pushState({}, '', idUrl.split(baseUrl)[1]);

                    $('.modal-content').animate({
                        scrollTop: wrapper.position().top-60
                    }, 500);
                    
                });
            });
        });
    }

    
}